import { https , httpsFile } from './http.js' ;

export function index (page,currentpage,search) {
    return https().get( `/release_code_assignment?page=${page}&currentpage=${currentpage}&search=${search}` )
}
export function getRelCodes () {
    return https().get( `/getRelCodes` )
}
// export function datatable(page,currentpage){
//     return httpsFile().get(`/permissions-table?page=${page}&currentpage=${currentpage}` )
// }
//
export function create ( formdata ) {
    return httpsFile().post( '/release_code_assignment' , formdata )
}
//
// export function edit ( permission ) {
//     return https().get( `/permission/${permission}/edit` )
// }
//
// export function update ( id, permission ) {
//     return httpsFile().post( `/permission/${id}` , permission )
// }
//
export function deleteAssignment ( id,relCode ) {
    return httpsFile().get( `/deleteAssignment?id=${id}&relCode=${relCode}` )
}